
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/living",
      function () {
        return require("private-next-pages/sa/living/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/living"])
      });
    }
  